











import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { deleteStamp, getStamp } from "@/api/stamp-api";
import StampEdit from "@/templates/StampEdit.vue";
import createStampOutput from "@/api/models/factories/createStampOutput";
import UploadFileSpec from "@/models/specs/UploadFileSpec";
import { Company, getOurCompanies } from "@/api/company-api";

@Component({
  components: {
    StampEdit
  }
})
export default class OfficeStampEditPage extends Vue {
  @Prop({ required: true }) id!: string;
  @Prop({ required: true }) companyId!: string;

  stamp = createStampOutput();
  isEdit = true;

  company: Company | null = null;
  companies: Company[] = [];

  updateIcon(e: Event) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || !files[0]) return;
    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }
    const url = URL.createObjectURL(files[0]);
    this.stamp.icon = url;
    this.stamp.image = files[0];
  }

  async ok() {
    await this.saveStamp();
    this.goShowPage();
  }

  cancel() {
    this.goShowPage();
  }

  async remove() {
    await this.deleteProject();
    this.goShowPage();
  }

  public async created() {
    this.initProject();
    await this.initCompanies();
  }

  private async initProject() {
    const p = await getStamp(Number(this.id));

    this.stamp = {
      id: Number(this.id),
      width: p.width,
      icon: p.image,
      image: null,
      height: p.height,
      top: p.top,
      left: p.left,
      officeId: p.officeId
    };
  }

  private async saveStamp() {
    if (!this.stamp) return;

    await this.$store.dispatch("saveStamp", this.stamp);
  }

  private async deleteProject() {
    await deleteStamp(this.id);
  }

  private goShowPage() {
    const params = { id: this.$route.params.companyId };
    this.$router.push({ name: "office-show", params });
  }

  private async initCompanies() {
    this.companies = await getOurCompanies();
    this.selectCompany();
  }

  @Watch("companyId")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.companyId);
    if (c) {
      this.company = { ...c };
    } else {
      this.company = null;
    }
  }
}
